import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Autocomplete, Checkbox, TextField } from '@mui/material';
// import { ApprDialog } from '@/common/appr/ApprDialog';
import { TitleButton } from '@/common/buttons/TitleButton';
import { useDialog } from '@/common/dialog/DialogContext';
import { SubDialog } from '@/common/dialog/SubDialog';
import { EntityBoard } from '@/common/entityFramework/entityBoard/EntityBoard';
// import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { DateUtils } from '@/common/utils/DateUtils';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useMemo, useState } from 'react';

export const McdBoard = () => {

  // const module = useModuleFromRoute();
  const rsrc = useRsrc();
  const { openDialog } = useDialog();

  /* 
  * State Filtering mechanics
  */
  const [selectedStates, setSelectedStates] = useState(
    localStorage.getItem('mcdSelectedStates') ? JSON.parse(localStorage.getItem('mcdSelectedStates')) : []
  );
  const [states, setStates] = useState(null);
  useEffect(() => {
    rsrc.rows('md', 'STATE', {}).then(res => setStates(res));
  }, []);

  useEffect(() => {
    localStorage.setItem('mcdSelectedStates', JSON.stringify(selectedStates));
  }, [selectedStates]);

  // TODO review and improve
  const postmarkPriority = (entityObj) => {
    const postmarkDate = entityObj.postmarkDate;
    const delta = DateUtils.daysBetween(postmarkDate, DateUtils.today());
    // TODO: Hardcoded to 38 days... this can be variably set by program
    const dueDateNormalizedDelta = Math.round(delta / 3.8);
    const tooltip = dueDateNormalizedDelta > 10 ? `${delta - 38} days past due date` : null;
    return { index: dueDateNormalizedDelta, tooltip };
  }

  /** @type {SlotSpec[]} */
  const slotSpecs = useMemo(() => {

    let draftExpr = ExprUtils.whereParams('status', ['DRAFT', 'VALIDATING']);
    let loadedExpr = ExprUtils.and(draftExpr, ExprUtils.is('loaded', true), ExprUtils.is('disputed', false));
    let disputedExpr = ExprUtils.and(draftExpr, ExprUtils.is('loaded', true), ExprUtils.is('disputed', true));

    let prepSlotSpecs = [
      {
        id: 'claim',
        title: 'Claims',
        entity: 'MCD_CLAIM',
        rowsReq: { expr: ExprUtils.and(draftExpr, ExprUtils.isNot('loaded', true)) },
        fields: ['code', 'dueAmt', 'dispAmt'],
        canDropFrom: false,
        priority: postmarkPriority
      },

      {
        id: 'loadedClaim',
        title: 'Claims Loaded into Model N',
        entity: 'MCD_CLAIM',
        rowsReq: { expr: loadedExpr },
        fields: ['code', 'dueAmt', 'dispAmt'],
        canDropFrom: false,
        priority: postmarkPriority
      },

      {
        id: 'disputedClaim',
        title: 'Claims Disputed in Model N',
        entity: 'MCD_CLAIM',
        rowsReq: { expr: disputedExpr },
        fields: ['code', 'dueAmt', 'dispAmt'],
        canDropFrom: false,
        priority: postmarkPriority
      },

      // {
      //   id: 'augmentedClaim',
      //   title: 'Claims Disputes Augmented in Model N',
      //   entity: 'MCD_CLAIM',
      //   rowsReq: { expr: ExprUtils.whereParams('status', ['AUGMENTED']) },
      //   fields: ['code', 'dueAmt', 'dispAmt'],
      //   canDropFrom: false,
      //   priority: postmarkPriority
      // },
    ]

    // Augment with selected states if applicable
    if (selectedStates.length > 0) {
      prepSlotSpecs.forEach(slotSpec => {
        slotSpec.rowsReq.expr = ExprUtils.and(slotSpec.rowsReq.expr, ExprUtils.whereParams('stateId', selectedStates.map(state => state.id)));
      });
    }

    return prepSlotSpecs;
  }, [selectedStates]);

  const buttons = [
    <Autocomplete
      key="state-filter"
      multiple
      disableCloseOnSelect
      options={states}
      getOptionLabel={(opt) => opt.name}
      value={selectedStates}
      onChange={(_, newValue) => setSelectedStates(newValue)}
      renderOption={(props, option, { selected }) => (
        <li {...props}> <Checkbox style={{ marginRight: 8 }} checked={selected} /> {option.name} </li>
      )}
      renderInput={(params) => (
        <TextField {...params} variant="outlined" label="Filter by State" placeholder="Select states" />
      )}
      sx={{
        width: 600,
        '& .MuiOutlinedInput-root': {
          borderRadius: '20px'
        }
      }}
    />,
    <TitleButton dataTestId="sub-upload-button" icon={fas.faUpload} toolTip="Submit" onClick={() => openDialog(SubDialog, { data: { entity: 'MCD_UTIL' } })} />
  ]

  return (
    <EntityBoard title="Medicaid Board" icon={fas.faHospitalUser} buttons={buttons} slotSpecs={slotSpecs} />
  );
}